import classNames from 'classnames';
import type { FC } from 'react';
import { memo, useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { twMerge } from 'tailwind-merge';

import { ReactComponent as IconRefresh } from '../icons/icon-refresh.svg';
import { Tooltip } from './GraphModal/Tooltip';
import { Loader } from './Loader';

const messages = defineMessages({
  refresh: { defaultMessage: 'Refresh', id: 'rELDbB' },
});

interface Props {
  refreshAction: VoidFunction;
  isRefreshing?: boolean;
  className?: string;
  iconContainerClassName?: string;
  /** unset if `null`, defaults to 'items-center' if undefined (legacy). */
  verticalAlign?: 'items-center' | 'items-baseline' | null;
}

export const RefreshButton: FC<Props> = memo(function RefreshButton(props) {
  let { className, refreshAction, isRefreshing, iconContainerClassName, verticalAlign } = props;
  if (verticalAlign === undefined) verticalAlign = 'items-center';
  const refresh = useCallback(() => refreshAction(), [refreshAction]);
  return (
    <Tooltip content={<FormattedMessage {...messages.refresh} />}>
      <button type="button" onClick={refresh} className={twMerge('RefreshButton', className)}>
        <div className={classNames('flex gap-1', verticalAlign)}>
          <span className={classNames('scale-75', iconContainerClassName)}>
            {isRefreshing ? <Loader black /> : <IconRefresh />}
          </span>
        </div>
      </button>
    </Tooltip>
  );
});
